import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { ContractProcessor } from '../../_types/contract-processor';
import { ContractProcessorsService } from '../../_services/contracts-processors.service';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { UsersService } from 'src/app/modules/users/_services/users.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { CasesTypesService } from 'src/app/modules/cases-types/_services/cases-types.service';
import { CaseTypeProcessorContract } from 'src/app/modules/cases-types/_types/case-type-processor-contract';
import { CasesTypesProcessorContractsService } from 'src/app/modules/cases-types/_services/cases-types-processors-contracts.service';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-contract-processors-detail',
    templateUrl: './processors-detail.component.html',
    styleUrls: ['./processors-detail.component.css'],
    standalone: false
})
export class ContractProcessorsDetailComponent implements OnInit {
  
  public processorFormGroup!: RxFormGroup;

  public contractProcessor: ContractProcessor = new ContractProcessor();  
  public loading: boolean = false;  
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public processors: any = [];
  public processorsIds: Array<string> = [];
  public vipsCase: any = [{id: '0', name: 'No'}, {id: '1', name: 'Sí'}, {id: '-1', name: 'Todos'}];
  public casesTypes: any = [];
  public selectedCasesTypes: any[] = [];
  private prevCaseTypesContractProcessors: any[] = [];

  constructor(
    private config: DynamicDialogConfig,
    private contractProcessorsService: ContractProcessorsService,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private usersService: UsersService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,    
    private casesTypesService: CasesTypesService   ,
    private casesTypesProcessorContractsService: CasesTypesProcessorContractsService,
    private loginService: LoginService   
  ) {

    this.processorFormGroup = this.formBuilder.formGroup<ContractProcessor>(this.contractProcessor) as RxFormGroup;
  }
  

  async ngOnInit() {    

    this.contractProcessor.contractId = this.config.data.contractId;
    this.processorsIds = this.config.data.processorsIds;
            
    const draft = this.config.data.draft;
    if(draft){
      this.contractProcessor = draft.processor;
      this.processorFormGroup.patchValue(this.contractProcessor);
      this.processorFormGroup.patchValue({vipCase: this.contractProcessor.vipCase == null ? '-1' : (this.contractProcessor.vipCase ? '1' : '0')});
      this.selectedCasesTypes = [...draft.caseTypeIds];
    }else if(this.config.data.id!=null && this.config.data.id!='0'){
      await this.loadContractProcessor(this.config.data.id);
      if(!this.contractProcessor.allCasesTypes) this.loadCaseTypesProcessorContracts();
    }else{
      this.processorFormGroup.patchValue({vipCase: '-1'});
    }
    this.allowWrite = this.loginService.hasPermission("COMPANIES.WRITE");
    this.allowDelete = this.loginService.hasPermission("COMPANIES.DELETE");

    this.loadProcessors();
    this.loadCasesTypes();
  }
  
  async loadContractProcessor(id: string) {
    this.contractProcessor = await firstValueFrom(this.contractProcessorsService.get(id, { include: ['processor'] }));
        //si estamos editando, quitamos el actual de los tramitadores a añadir
    this.processorsIds = this.processorsIds.filter((x: any) => x != this.contractProcessor.processorId);

    this.processorFormGroup.patchValue(this.contractProcessor);   
    if(this.contractProcessor.vipCase == null) {
      this.processorFormGroup.patchValue({vipCase: '-1'});
    }else{
      if(this.contractProcessor.vipCase){
        this.processorFormGroup.patchValue({vipCase: '1'});
      }else{this.processorFormGroup.patchValue({vipCase: '0'}); }
    }
    
  }

  async loadCasesTypes() {
    let params:IParamsCollection = {
      sort: ['name']
    };
    let response = await firstValueFrom(this.casesTypesService.all(params));
    this.casesTypes = response.data;
    this.sortSelectedCasesTypes();
  }

  //ordena los tipos de daño seleccionados siguiendo el orden alfabetico de casesTypes
  sortSelectedCasesTypes() {
    if (this.casesTypes.length == 0 || this.selectedCasesTypes.length == 0) return;
    let sorted = this.casesTypes.filter((caseType: any) => this.selectedCasesTypes.includes(caseType.id)).map((caseType: any) => caseType.id);
    //si algun tipo de daño seleccionado no esta en la lista, no reordenamos para no perderlo
    if (sorted.length == this.selectedCasesTypes.length) this.selectedCasesTypes = sorted;
  }

  async loadProcessors(){
    let filters = {
      'userType': new Filter(FilterOperation.equals, 'userType.code', '', 'processor')
    };
    let params:IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build(),
      page: { number: 1, size: 2000 } 
    };
    let response = await firstValueFrom(this.usersService.all(params));
    this.processors = response.data;//QUe permita añadir el procesador varias vaces porque puede ser con distinto tipo de daño/porcentaje..filter((x: any) => x.id == this.contractProcessor.processorId || !this.processorsIds.some((y: any) => y == x.id));  
  }

  async loadCaseTypesProcessorContracts() {

    this.casesTypesProcessorContractsService
     let filters = {
      'contractProcessorId': new Filter(FilterOperation.equals, 'contractProcessorId', '', this.contractProcessor.id),
      'procesorId': new Filter(FilterOperation.equals, 'processorId', '', this.contractProcessor.processorId),
      'contractId': new Filter(FilterOperation.equals, 'contractId', '', this.contractProcessor.contractId)
    };
    let params:IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.casesTypesProcessorContractsService.all(params));
    this.prevCaseTypesContractProcessors = response.data;
    this.selectedCasesTypes = response.data.map((m: any) => m.caseTypeId);
    this.sortSelectedCasesTypes();
  }


  async save() {

    let valid = this.formValidationService.validateForm(this.processorFormGroup);
    if (valid) {
      this.contractProcessor = Object.assign(this.contractProcessor, this.processorFormGroup.value);
      this.contractProcessor.vipCase = this.processorFormGroup.value.vipCase === "-1" ? null : (this.processorFormGroup.value.vipCase == "0" ? false : true);
      if(this.selectedCasesTypes.length == 0){ this.contractProcessor.allCasesTypes = true;}else{
        this.contractProcessor.allCasesTypes = false;
      }

      if(!this.contractProcessor.contractId){
        this.contractProcessor.processor = this.processors.find((x: any) => x.id == this.contractProcessor.processorId);
        this.dynamicDialogRef.close({
          processor: this.contractProcessor,
          caseTypeIds: this.selectedCasesTypes,
          caseTypes: this.casesTypes.filter((x: any) => this.selectedCasesTypes.includes(x.id))
        });
        return;
      }

      let contractProcessorCreated = await firstValueFrom(this.contractProcessorsService.save(this.contractProcessor));

        if(this.selectedCasesTypes.length > 0){
  
            let casesTypesExistIds = this.prevCaseTypesContractProcessors.map(x => x.caseTypeId);            
            let toAdd = this.selectedCasesTypes.filter(x => !casesTypesExistIds.includes(x));
            let toRemove = casesTypesExistIds.filter(x => !this.selectedCasesTypes.includes(x));
           
            const addPromises = toAdd.map(caseTypeId => {
              let caseTypeProcessorContract = new CaseTypeProcessorContract();
                caseTypeProcessorContract.caseTypeId= caseTypeId;
              caseTypeProcessorContract.processorId= this.contractProcessor.processorId;
              caseTypeProcessorContract.contractId= this.contractProcessor.contractId;
              caseTypeProcessorContract.contractProcessorId = contractProcessorCreated.id as string;
              return this.casesTypesProcessorContractsService.save(caseTypeProcessorContract);
            });
    
            const removePromises = toRemove.map(caseTypeId => {
              let fileToRemove = this.prevCaseTypesContractProcessors.find(x => x.caseTypeId == caseTypeId);
              return firstValueFrom(this.casesTypesProcessorContractsService.delete(fileToRemove?.id));
            });
    
            // Esperar a que todas las promesas se completen
            Promise.all([...addPromises, ...removePromises]);
            this.selectedCasesTypes = [];
          
        }else{          
          //Comprobar queno existieran antes, si es asi borrarlos
          if(this.prevCaseTypesContractProcessors.length > 0){
            this.prevCaseTypesContractProcessors.forEach((caseTypeProcessorContract: any) => {
              this.casesTypesProcessorContractsService.delete(caseTypeProcessorContract.id);
            });
          }
        }
      

       
      this.dynamicDialogRef.close();
      this.messageService.add({ closable: true, severity: 'success', detail: "Tramitador guardado correctamente" });
    }else{
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });    
    }
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Quieres eliminar el tramitador " + this.contractProcessor.processor?.name+ "?",
      header: "Eliminar tramitador",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractProcessorsService.delete(this.contractProcessor.id).subscribe(
          (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Tramitador eliminado correctamente" });

            this.cancel();
          },
          (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        );
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }    

}
